module.exports = __webpack_public_path__ + "img/cooperationImg12.01bd6879.png";